import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import moment from 'moment'
import {getMediaWallProgram} from '@apis'

const playTitle = [
  '当前播放节目',
  '下次播放节目'
]
let timer = null

const ProgtamList = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [playType, setPlayType] = useState(0)
    const [playProgram, setPlayProgram] = useState('暂无')
    const [playNextProgram, setPlayNextProgram] = useState('暂无')
  
    async function queryOnlineRate() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId
      }
      const res = await getMediaWallProgram(params)
      if(res && res.data) {
        res.data.map(item => {
          if(item.playStatus == 1) {
            setPlayProgram(item.name)
          }
          if(item.taskSwitch == 1) {
            if(item.playFrequency == 1) {
              item.weekList.map(e => {
                if(e == new Date().getDay()) {
                  item.timeThresholdList.map(i => {
                    if(moment(Number(i.playTimeStart)).format('HH:mm:ss') > moment(new Date()).format('HH:mm:ss')) {
                      setPlayNextProgram(item.name)
                    }
                  })
                }
              })
            } else {
              if(moment(new Date()).format('HH:mm:ss') > moment(Number(item.playDayStart)).format('HH:mm:ss') 
              && moment(new Date()).format('HH:mm:ss') < moment(Number(item.playDayEnd)).format('HH:mm:ss')) {
                setPlayNextProgram(item.name)
              }
            }
          } 
        })
      }
    }
    useEffect(() => {
      queryOnlineRate()
    }, [])

    clearInterval(timer)
    timer = setInterval(function() {
      if(playType) {
        setPlayType(0)
      } else {
        setPlayType(1)
      }
    }, 10000)

    return (
      <div className='ck-index-pg'>
        <div className='pg-title'>节目播放计划</div>
        <div className='pg-item'>
          <div className='pg-index'>
            <tr className='pg-time'>
              <td>{playTitle[playType]}:</td>
              <td style={{paddingLeft: '30px'}}>{playType ? playNextProgram : playProgram}</td>
            </tr>
          </div>
        </div>
      </div>
    )
  })
)

export default ProgtamList